import { createStart, createMiddleware } from "@tanstack/react-start";

import { renderErrorPage } from "./lib/error-page";
import { attachSupabaseAuth } from "@/integrations/supabase/auth-attacher";

// NOTE: `attachSupabaseAuth` intentionally NOT registered.
// This site has zero server functions guarded by `requireSupabaseAuth`
// (public marketing site — leads insert via anon RLS from the browser).
// Registering the attacher pulls the full Supabase auth-js + realtime +
// storage modules into the initial client bundle (~300 KiB uncompressed),
// blocking LCP for no benefit. Re-add ONLY if a `createServerFn` with
// `.middleware([requireSupabaseAuth])` is introduced.

const errorMiddleware = createMiddleware().server(async ({ next }) => {
  try {
    return await next();
  } catch (error) {
    if (error != null && typeof error === "object" && "statusCode" in error) {
      throw error;
    }
    console.error(error);
    return new Response(renderErrorPage(), {
      status: 500,
      headers: { "content-type": "text/html; charset=utf-8" },
    });
  }
});

export const startInstance = createStart(() => ({
  functionMiddleware: [attachSupabaseAuth],
  requestMiddleware: [errorMiddleware],
}));
